module.exports = __webpack_public_path__ + "img/siamrath-logo.bce28d6e.png";